import { defineStore } from 'pinia'
import localSave from '@utils/local-save'

export const SIDEBAR_COLLAPSED_KEY = 'nav.sidebarCollapsed'

// Shell state that is the visitor's own choice (PRD rule 6: remembered per device,
// expanded by default). The tablet tier ignores it — the rail is locked there — the
// layout decides, the store only remembers. localSave is null-safe without a window.
export const useNavigationStore = defineStore('navigation', {
    state: () => ({
        isSidebarCollapsed: localSave.get<boolean>(SIDEBAR_COLLAPSED_KEY) === true,
    }),
    actions: {
        setSidebarCollapsed(value: boolean) {
            this.isSidebarCollapsed = value
            localSave.save(SIDEBAR_COLLAPSED_KEY, value)
        },
        toggleSidebar() {
            this.setSidebarCollapsed(!this.isSidebarCollapsed)
        },
    },
})
